import React, { Component } from 'react'
import { change as changeAction } from 'redux-form'
import { connect } from 'react-redux'

import { Create } from 'components/detail'
import { SimpleFormNoInit } from 'components/form'
import { TextInput, DatetimeInput, SelectInput, FileInput } from 'components/input'
import { FileField, ImageField } from 'components/field';
import {
  InputOptions
} from 'util/constants'

import { maxLength } from 'components/form';

import * as urls from './urls'
import * as utils from './utils'

class NotificationCreateBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('message_type', record['message_type']);
    formDataRecord.append('title', record['title']);
    formDataRecord.append('body', record['body']);
    formDataRecord.append('app_type', record['app_type']);
    if(!!record['url'])
      formDataRecord.append('url', record['url']);
    formDataRecord.append('send_type', record['send_type']);
    formDataRecord.append('delivery_type', record['delivery_type']);
    formDataRecord.append('status', record['status']);
    if (record['image_data']) {
      formDataRecord.append('image_data', record['image_data']);
    }
    if (record['shop_ids_file_data']) {
      formDataRecord.append('shop_ids_file_data', record['shop_ids_file_data']);
    }
    if (record['delivery_time']) {
      formDataRecord.append('delivery_time', record['delivery_time']);
    }

    props.crudCreate(props.resource, formDataRecord, props.createBackendPath, basePath);
  };

  render() {
    const { submitFailed, syncErrors, formValues } = this.props;

    return (
      <Create createBackendPath={urls.notificationCreateBackendPath}
              handleSubmit={this.handleSubmit} {...this.props}>
        <SimpleFormNoInit>
          <SelectInput
            source='message_type'
            label='Notification type'
            isRequired={true}
            choices={utils.MESSAGE_TYPE_CHOICES}
            defaultValue={utils.MESSAGE_TYPE_TEXT} />
          { formValues.message_type === utils.MESSAGE_TYPE_ARTICLE && (
            <FileInput 
              source='image_data' 
              isRequired={true} 
              placeholder={<p>Upload cover picture</p>}
              accept="image/*"
            >
              <ImageField isRequired={true} source="src" title="title"/>
            </FileInput>
          )}
          {
            submitFailed && syncErrors.image_data ?
            <div style={{position: 'relative', bottom: '15px', color: 'rgb(244, 67, 54)',
              fontSize: '12px', lineHeight: '12px',
              transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'}}>
              <p>{syncErrors.image_data}</p>
            </div>
              : <span />
          }

          <TextInput source='title' label='Title' validators={[maxLength(128)]} isRequired={true}
                     options={InputOptions} />
          <TextInput source='body' label='Body' isRequired={true} options={InputOptions} />

          <SelectInput
            source='app_type'
            label='Target App'
            isRequired={true}
            choices={utils.APP_TYPE_CHOICES}
            defaultValue={utils.APP_TYPE_ALL}
          />

          <TextInput 
            source='url' 
            label='URL / In App page' 
            isRequired={false}
            options={InputOptions}
          />

          <SelectInput 
            source='send_type'
            label='Target Users'
            isRequired={true}
            choices={utils.SEND_TYPE_CHOICES}
            defaultValue={utils.MESSAGE_SEND_ALL}
          />
          { formValues.send_type === utils.MESSAGE_SEND_SPECIFIC_USERS && (
            <FileInput 
              source="shop_ids_file_data"
              label="Shop ids file"
              isRequired={true}
            >
              <FileField source="src" title="title" />
            </FileInput>
          )}
          {
            submitFailed && syncErrors.shop_ids_file_data ?
              <div style={{position: 'relative', bottom: '15px', color: 'rgb(244, 67, 54)',
                fontSize: '12px', lineHeight: '12px',
                transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'}}>
                <p>{syncErrors.shop_ids_file_data}</p>
              </div>
              : <span />
          }

          <SelectInput
            source='delivery_type'
            label='Deliver Type'
            isRequired={true}
            choices={utils.NOTIFICATION_DELIVER_TYPE_CHOICES}
            defaultValue={utils.NOTIFICATION_DELIVER_NOW}
            options={InputOptions}
            onChange={(e, value) => {
              if (value === utils.NOTIFICATION_DELIVER_NOW) {
                this.props.resetStatus();
              }
            }}
          />
          {
            formValues.delivery_type === utils.NOTIFICATION_DELIVER_LATER &&
            <DatetimeInput
              source='delivery_time'
              label='Delivery Time'
              isRequired={true}
              options={InputOptions}
              optionsTime={InputOptions}
            />
          }
          <SelectInput
            source='status'
            label='Status'
            disabled={formValues.delivery_type === utils.NOTIFICATION_DELIVER_NOW}
            choices={utils.NOTIFICATION_STATUS_EDIT_CHOICES}
            options={InputOptions}
            defaultValue={utils.NOTIFICATION_STATUS_PENDING}
          />
        </SimpleFormNoInit>
      </Create>
    )
  }
}

export const NotificationCreate = connect(
  (state) => {
    return {
      submitFailed: (state.form['record-form'] || {}).submitFailed,
      syncErrors: ((state.form['record-form'] || {}).syncErrors || {}),
      formValues: ((state.form['record-form'] || {}).values || {}),
    }
  },
  {
    change: changeAction,
    resetStatus: () => (changeAction('record-form', 'status', utils.NOTIFICATION_STATUS_PENDING)),
  }
)(NotificationCreateBase);



// WEBPACK FOOTER //
// ./src/routes/notification/NotificationCreate.js